import React, { useEffect, useState } from "react";
import API from "../Services/ProductType";

const ProductType = ({ selectedProductType, setSelectedProductType, type, onSalesTabChange, SalesTab, updateProductType = [], location_id = null, is_loction_base = 0 }) => {
    const [productType, setProductType] = useState([]);
    const [error, setError] = useState(null);
    const handleChange = (e) => {
        setSelectedProductType(e.target.value);
    };

    if (is_loction_base == 1) {
        console.log('is_loction_base', is_loction_base)
    }

    const bindProductType = async () => {
        try {
            const saleTabId = SalesTab || 0;
            const isMultiple = saleTabId.length > 1 ? 1 : 0;
            const payload = {
                is_active: 1,
                is_combo: false,
                sale_tab_id: saleTabId,
                is_multiple: isMultiple,
                location_id: location_id
            };
            console.log(payload, "iuteetyuio")
            const response = await API.Get_Product_Type(payload);
            let result = response?.data?.data || [];
            const formattedData = result.map(item => {
                return {
                    id: item.id,
                    name: item.name
                };
            });
            setProductType(formattedData);
            //console.log('bindProductType')
           // console.log('formattedData111111111', formattedData);
            setError(null);
        } catch (error) {
            console.error("Error fetching product types:", error);
            setError("Failed to fetch product types. Please try again.");
            setProductType([]);  // Clear product types on error
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };
    useEffect(() => {

        if (
            type === "All" ||
            (SalesTab !== null && SalesTab !== undefined) ||
            (type !== true && type !== false)
        ) {
            bindProductType();
        }
    }, [type, SalesTab]);

    useEffect(() => {
        if (updateProductType.length > 0) {
            setProductType(updateProductType);
        }
    }, [updateProductType]);
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="Designation">Product Type <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" onScroll={true} id="ddlproducttype" value={selectedProductType} onChange={handleChange}>
                        <option value="">Select</option>
                        {productType.length > 0 ? (
                            productType.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.name}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Product Type available</option>
                        )}
                    </select>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default ProductType;
